import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faCircleCheck,
	faCircleInfo,
	faCircleQuestion,
	faExternalLinkAlt,
	faMars,
	faTriangleExclamation,
	faVenus
} from '@fortawesome/free-solid-svg-icons';

// Add icons to the library so they can be used throughout the app
library.add(
	faCircleCheck,
	faCircleInfo,
	faCircleQuestion,
	faExternalLinkAlt,
	faMars,
	faTriangleExclamation,
	faVenus
);
